import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { ObserversModule } from '@angular/cdk/observers';

import { TranslateModule } from '@ngx-translate/core';

import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule } from 'ng-zorro-antd/popover';

import { TourRootDirective } from '@app/shared/modules/tour/directives/tour-root.directive';
import { TourStepDirective } from '@app/shared/modules/tour/directives/tour-step.directive';
import { TourButtonComponent } from '@app/shared/modules/tour/components/tour-button/tour-button.component';
import { TourStepContainerDirective } from '@app/shared/modules/tour/directives/tour-step-container.component';
import { TourIntercomDirective } from '@app/shared/modules/tour/directives/tour-intercom.directive';
import { TourIntercomHideDirective } from '@app/shared/modules/tour/directives/tour-intercom-hide.directive';

@NgModule({
  declarations: [
    TourRootDirective,
    TourStepDirective,
    TourButtonComponent,
    TourStepContainerDirective,
    TourIntercomDirective,
    TourIntercomHideDirective,
  ],
  exports: [
    TourRootDirective,
    TourStepDirective,
    TourButtonComponent,
    TourStepContainerDirective,
    TourIntercomDirective,
    TourIntercomHideDirective,
  ],
  imports: [TranslateModule, NzToolTipModule, NzPopoverModule, NgIf, AsyncPipe, OverlayModule, ObserversModule],
})
export class TourModule {}
